import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import EstatePlanningProfileSubpageFooterImage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/EstatePlanningProfileSubpage/EstatePlanningProfileSubpageFooterImagePicker/EstatePlanningProfileSubpageFooterImage';

const EstatePlanningProfileSubpageFooterImagePicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.footerImage.name]: (<EstatePlanningProfileSubpageFooterImage imageURL={resource.relationship(fr.relationships.footerImage.name)?.link('related')?.url()} />),
  }, null);
};

EstatePlanningProfileSubpageFooterImagePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
EstatePlanningProfileSubpageFooterImagePicker.defaultProps = {};

export default EstatePlanningProfileSubpageFooterImagePicker;
